// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604090903/js/" + chunkId + "." + {"44":"57f48b50","225":"4dca4664","481":"032a9c80","486":"d9622307","770":"b8731a29"}[chunkId] + ".0.3809217007621821.chunk.js";
};